// Services.tsx
import React from "react";
import "./Services.css";
import { motion } from "framer-motion";
import ParticlesBackground from "./ParticlesBackground";
import { useNavigate } from 'react-router-dom';


const services = [
  {
    title: "Website Design",
    description:
      "Custom, modern designs tailored to your brand's vision and goals. From landing pages to full-scale platforms, we deliver responsive and elegant websites that impress.",
    icon: "➜",
  },
  {
    title: "UI/UX Prototyping",
    description:
      "Interactive wireframes, user flow diagrams, and hi-fi mockups that ensure your product is intuitive and user-friendly. We test, iterate, and perfect your experience.",
    icon: "➜",
  },
  {
    title: "E-commerce Solutions",
    description:
      "Fully functional online stores built with secure payment integrations, user accounts, inventory management, and mobile responsiveness to help your business scale.",
    icon: "➜",
  },
  {
    title: "Responsive Development",
    description:
      "From desktop monitors to mobile screens, we ensure that your website adjusts beautifully to all devices. Built with modern frameworks for speed and accessibility.",
    icon: "➜",
  },
  {
    title: "Brand Identity",
    description:
      "We help you define your brand with custom logos, typography, color schemes, and visual guidelines — everything needed to present a consistent and strong identity.",
    icon: "➜",
  },
];

const spinVariant = {
  initial: { rotate: 0 },
  hover: { rotate: 360, transition: { duration: 0.6, ease: "easeInOut" } },
};

const Services: React.FC = () => {
        const navigate = useNavigate();

  return (
    <div className="services-container">
      <ParticlesBackground />
      <div className="animated-bg" />
      <motion.h2
        className="services-heading"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Our Services
      </motion.h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div
            className="service-card"
            key={index}
            whileHover="hover" 
            initial="initial"
            transition={{ delay: index * 0.2, duration: 0.5 }}
          >
            <motion.div className="service-icon" variants={spinVariant}>
              {service.icon}
            </motion.div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </div>

      <motion.button
      onClick={() => navigate('/consultation')}
        className="consult-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        Book a Consultation
      </motion.button>
    </div>
  );
};

export default Services;
